import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';

const AppActiveTaskComp = (props) => {
  const { t } = useTranslation();
  const { getApplicationStatus, application_id, role_id } = props;
  useEffect(() => {
    getApplicationStatus(application_id, role_id);
  }, [getApplicationStatus, application_id, role_id]);

  const rowItems = [];
  var i = 1;
  props.application_status_list.forEach((element) => {
    var status = '';
    if (!element.completed) {
      status = 'Pending';
    }
    if (parseInt(element.role_id, 10) === parseInt(props.role_id, 10)) {
      status = 'Current User';
    }
    rowItems.push(
      <TableRow key={element.id}>
        <TableCell>
          {i}
        </TableCell>
        <TableCell>
          {element.user_name}
          ,
          <br />
          {element.user_email}
          <br />
          {element.user_rank === "NA" ? "" : element.user_rank}
          <br />
          {element.user_dept_alias === "" ? element.user_dept_name : element.user_dept_alias}
          <br />
        </TableCell>
        <TableCell>
          {element.role_alias === '' ? element.role_title : element.role_alias}
        </TableCell>
        <TableCell>{element.task_alias === '' ? element.task_title : element.task_alias}</TableCell>
        <TableCell>{element.app_title}</TableCell>
        <TableCell>
          <div style={{ color: status === 'Pending' ? 'red' : 'blue' }}>{status === 'Pending' ? t('app_detail_active_task_pending') : t('app_detail_active_task_current_user')}</div>
          <br />
          {t('app_detail_active_task_reminders')}:
          {' '}
          {element.reminders}
        </TableCell>
      </TableRow>,
    );
    i++;
  });
  return (
    <div>
      <Card>
        <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
          <Typography variant="h5" gutterBottom>{t('app_detail_active_task_title')}</Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t('app_detail_active_task_serial')}</TableCell>
                <TableCell>{t('app_detail_active_task_assigned_to')}</TableCell>
                <TableCell>{t('app_detail_active_task_role')}</TableCell>
                <TableCell>{t('app_detail_active_task_task_name')}</TableCell>
                <TableCell>{t('app_detail_active_task_application')}</TableCell>
                <TableCell>{t('app_detail_active_task_status')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowItems}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default AppActiveTaskComp;
